import { ModelBase } from '@barthauer/abc/core/data';
import { ExportMode } from '@barthauer/abc/interfaces/core/wizards/wizard-export';

export class M150WizardTransferObject {
  settingDocument: M150WizardSettingDocument;
  exportMode: M150WizardExportMode;
  constructor() {}
}

export class M150WizardSettingDocument {
  public id: string;
  public name?: string;
  constructor(data: any) {
    Object.assign(this, data);
  }
}
export class M150WizardExportMode {
  public selectedMode: ExportMode;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class M150ExportQueryModel extends ModelBase {
  BCEDocumentId?: string;
  ExteriorPolygon?: number[][];

  constructor() {
    super();
  }
}
